module.exports = __webpack_public_path__ + "img/map-hours-table-navy.8108a4f5.png";